import { useApiClient } from '@/api/client.js'
import { CheckInClientSchema, type CheckInClient } from '../types.ts'

export const REMOVE_NEXT_CLIENT_FROM_LIST = '/core/v2/business_api/me/businesses/{businessId}/turntracker/list/next_client'

export const removeNextClientFromList = (options: {
  businessId: number;
}) => {
  const apiClient = useApiClient()

  return apiClient.delete({
    url: REMOVE_NEXT_CLIENT_FROM_LIST,
    urlParams: {
      businessId: options.businessId,
    },
  })
    .then(({ data }) => CheckInClientSchema.parse(data))
}
